import { Injectable } from '@angular/core';

export interface ChatMessage {
  type: 'user' | 'bot';
  text: string;
  sql?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AiChatService {
  messages: ChatMessage[] = [];
}
